/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from 'react';
import {
  PersonContainer,
  DescriptionContainer,
  LeftDesc,
  RightDesc,
  PrimaryText,
  SecondaryText,
  Counter,
  CounterButton,
  NudgeContainer,
  NudgeDesc,
} from './styles';
import { IPersonCount, LimitType } from 'src/international-insurance/interface';
import { ASSETS } from 'src/common/utils/config';
import Image from 'next/image';

const Index = (props: IPersonCount) => {
  const {
    title = '',
    sub_title = '',
    count = 0,
    minLimit = 0,
    maxLimit = null,
    note = null,
    category = '',
    handleUpdate,
  } = props;
  const [max, setMax] = useState<LimitType>();
  const [min, setMin] = useState<number>();
  const [counter, setCounter] = useState<number>(count);

  useEffect(() => {
    const temp = minLimit;
    setMin(temp);
    if (maxLimit) setMax(maxLimit);
  }, []);

  useEffect(() => {
    setCounter(count);
  }, [count]);

  useEffect(() => {
    const data = { counter, category };
    handleUpdate(data);
  }, [counter]);

  const incrementCounter = () => {
    let temp: number;
    if (max) temp = Math.min(max, counter + 1);
    else temp = counter + 1;

    if (counter === 0 && temp === counter + 1) {
      setTimeout(() => {
        setCounter(temp);
      }, 50);
    } else setCounter(temp);
  };

  const decrementCounter = () => {
    let temp;
    if (min) temp = Math.max(min, counter - 1);
    else temp = Math.max(0, counter - 1);

    setCounter(temp);
  };

  return (
    <>
      <PersonContainer>
        <DescriptionContainer>
          <LeftDesc>
            <PrimaryText>{title}</PrimaryText>
            <SecondaryText>({sub_title})</SecondaryText>
          </LeftDesc>
          <RightDesc className="disable-dbl-tap-zoom">
            <CounterButton
              disabled={counter === min}
              onClick={() => decrementCounter()}
            >
              {'—'}
            </CounterButton>
            <Counter>{counter || 0}</Counter>
            <CounterButton
              disabled={max && counter === max}
              onClick={() => incrementCounter()}
            >
              {'+'}
            </CounterButton>
          </RightDesc>
        </DescriptionContainer>
      </PersonContainer>
      {note && (
        <NudgeContainer counter={counter}>
          <Image src={ASSETS.BLACK_INFO_ICON} height={'16px'} width={'16px'} />
          <NudgeDesc>{note?.text}</NudgeDesc>
        </NudgeContainer>
      )}
    </>
  );
};

export default Index;
